import type { IconButtonProps } from '@mui/material';
import { IconButton } from '@mui/material';
import { blueGrey } from '@mui/material/colors';

type HomePageSidebarButtonWrapperProps = {
  isSelected?: boolean;
  children: React.ReactNode;
} & IconButtonProps;

export const HomePageSidebarButtonWrapper: React.FC<HomePageSidebarButtonWrapperProps> = ({ isSelected, children, ...buttonProps }) => {
  return (
    <IconButton
      sx={{
        backgroundColor: isSelected ? blueGrey[50] : 'transparent',
        height: '40px',
        width: '40px',
        borderRadius: '10px',
        position: 'relative',
      }}
      {...buttonProps}
    >
      {children}
    </IconButton>
  );
};